import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const MultiAuthorSignings = () => <EventCategoryPage config={EVENT_CATEGORIES['multi-author-signings']} data-id="element-9184" data-mp="gjrmzavw3047" />;
export default MultiAuthorSignings;